/**
 * User
 */
import Config from './Config';
import Util from './Util';
import GameInfo from './GameInfo';

const User: any = {
  isCheckNotExistGameAccount: () => {
    if (Config.checkWriteNotExistGameAccount && (!GameInfo.getGameName() || !GameInfo.getGameServerId())) {
      return true;
    }

    return false;
  },

  setUser: (articleList: any, param: any) => {
    const usr: any = {};
    const replaceList: any = {
      '<': '&lt;',
      '>': '&gt;',
    };

    // user 게시판 예외처리
    const originList = articleList;

    // 북마크 게시글 더보기 구현 시 previousArticleId 파라미터에 screapId 값을 사용함.
    usr.scrapId = (articleList.scrapId && !Config.isUuid) ?
        articleList.scrapId : (articleList.scrapArticle && articleList.scrapArticle.reactionRef) ?
            articleList.scrapArticle.reactionRef : NaN;

    // if (!articleList.articleId) {
    //   if(Config.isUuid) {
    //     if( !!usr.scrapId ) {
    //       articleList = articleList.scrapArticle;
    //     } else if (articleList.userArticle) {
    //       articleList = articleList.userArticle;
    //     } else {
    //       articleList = articleList.article.contentMeta;
    //     }
    //   }
    // }

    // N커뮤니티
    if ( Config.isUuid && !( param.indexOf('searchType=hash') !== -1 ) ) {
      // 북마크 게시판
      if ( originList.scrapArticle ) {
        articleList = originList.scrapArticle.article.contentMeta;

        // 유저 게시판
      } else if ( originList.userArticle ) {
        articleList = originList.userArticle.article.contentMeta;
        // 일반 게시판
      } else {
        articleList = articleList.article.contentMeta;
      }
      usr.categoryName =  articleList.categoryBoard.boardName;
      usr.boardAlias = articleList.rootBoard.board.boardAlias;
      usr.articleId = articleList.id;
      usr.previousArticleId =  ( originList.userArticle &&  originList.userArticle.reactionRef ) ?
          originList.userArticle.reactionRef : '';
      usr.url = articleList.rootBoard.board.boardUrlPattern;
      usr._postDate = Util.toISOString(new Date(articleList.timestamps.postedAt));
      usr.hitCount = articleList.reactions.viewCount;
      usr.goodCount = articleList.reactions.likeCount;
      usr.commentCount = articleList.reactions.commentCount;
      usr.hasVote = !!articleList.voteRef;
    } else {
      // My API has article object for SNOW3
      if (!articleList.articleId ) {
        articleList = articleList.article;
      }
      usr.categoryName = ( originList.board && originList.board.boardName ) ?
          originList.board.boardName : articleList.category.categoryName;
      usr.boardAlias = articleList.boardAlias;
      usr.articleId = articleList.articleId;
      usr.url = articleList.url;
      usr._postDate = articleList.postDate;
      usr.hitCount = articleList.hitCount;
      usr.goodCount = articleList.goodCount;
      usr.commentCount = articleList.commentCount;
      usr.hasVote = articleList.hasVote;
    }

    if ( usr.url ) {
      if (usr.url.indexOf('{articleId}') !== -1) {
        usr.url = usr.url.replace('{articleId}', usr.articleId );
      }
      if( usr.url.indexOf('{boardAlias}') !== -1 ) {
        usr.url = usr.url.replace('{boardAlias}', usr.boardAlias );
      }
    }

    if ( Config.useAPIListUrl && usr.url ) {
      usr._url = `${usr.url}${param}`;
    } else {
      usr._url = `${Config.viewPage}?articleId=${usr.articleId}${param}`;
    }

    // user custom url
    if (Config.prefixPath) {
      usr._url = `${Config.prefixPath}/board/${usr.boardAlias}/${Config.viewPage}?articleId=${usr.articleId}${param}`;
    }

    usr._writer = Util.setDefaultByEmptyString(articleList.writer);
    usr._adminUser = usr._writer.admin || usr._writer.adminUser;
    usr._gameUser = Util.setDefaultByEmptyString(usr._writer.gameUser);
    usr._loginUser = Util.setDefaultByEmptyString(usr._writer.loginUser);
    usr._emoticonUrl = Util.setDefaultByEmptyString(articleList.emoticonUrl || usr._writer.emoticonUrl);
    usr.writerInfo = usr._loginUser.name;
    usr._server = '';

    // @TODO List
    usr._gameCharacterId = Util.setDefaultByEmptyString(usr._gameUser.gameCharacterId);
    usr._gameCharName = Util.setDefaultByEmptyString(usr._gameUser.gameCharacterName);
    usr._gameServerId = Util.setDefaultByEmptyString(usr._gameUser.gameServerId);
    usr._loginName = Util.setDefaultByEmptyString(usr._loginUser.name);
    usr.isMyArticle = Config.guid && Config.guid === usr._loginUser.uid;

    if (!usr._loginUser.uid && usr._gameUser) {
      usr.isMyArticle = GameInfo.isEqualGameUser(usr._gameUser.gameCharacterName, usr._gameUser.gameServerId);
    }

    if (!usr.isMyArticle && usr._loginUser.name) {
      usr.isMyArticle = GameInfo.isEqualLoginName(usr._loginUser.name, usr._gameUser.gameServerId);
    }

    if (
      Config.isUserInfoWithServer &&
      Config.serverName &&
      usr._gameUser && usr._gameUser.gameServerId
    ) {
      if (GameInfo.getSite() === 'bns') {
        if( usr._gameUser.gameCode === Config.bnsServerType.LIVE ) {
          usr._server = `<span class="server">${Util.setDefaultByEmptyString(Config.serverName.LIVE[usr._gameUser.gameServerId])}</span>`;
        } else if ( usr._gameUser.gameCode === Config.bnsServerType.FRONTIER ) {
          usr._server = `<span class="server">${Util.setDefaultByEmptyString(Config.serverName.FRONTIER[usr._gameUser.gameServerId])}</span>`;
        }
      } else {
        usr._server = `<span class="server">${Util.setDefaultByEmptyString(Config.serverName[usr._gameUser.gameServerId])}</span>`;
      }
    }

    if (!Config.isBnsApp) {
      const userName = usr._loginUser.name || usr._gameUser.gameCharacterName || '';
      usr.writerInfo =
        !Config.isMyProfile || usr._adminUser
          ? `${userName}`
          : `<a href="${GameInfo.userProfile(usr._loginUser.uid, Config.guid, usr._gameUser.gameCharacterName, usr._gameUser.gameServerId)}">${userName}</a>`;
    }

    // character + server
    // bns 서고
    if (Config.writerInfo) {
      usr._writerContents = (articleList.reservedFields && articleList.reservedFields[Config.writerInfo] && articleList.reservedFields[Config.writerInfo].contents) ? articleList.reservedFields[Config.writerInfo].contents : ''
      usr.writerInfo = usr._writerContents && usr._writerContents.writing ? '글: ' + usr._writerContents.writing : '';
      usr.writerInfo = usr._writerContents && usr._writerContents.picture ? `${usr.writerInfo} / 그림: ${usr._writerContents.picture}` : `${usr.writerInfo}`;
      usr.writerInfo = usr._writerContents && usr._writerContents.illustrator ? `${usr.writerInfo} / 일러스트: ${usr._writerContents.illustrator}` : `${usr.writerInfo}`;
    } else if (!Config.isBnsApp && usr._gameUser && usr._gameUser.gameCharacterName) {
      usr.writerInfo = Config.isMyProfile
        ? `<a href="${GameInfo.gameUserProfile(
            usr._gameUser.gameUserUid,
            usr._loginUser.uid,
            Config.guid,
            usr._gameUser.gameCharacterName,
            usr._gameUser.gameServerId,
            usr._gameUser.gameCharacterId,
            usr._gameUser.gameCode)}">${usr._gameUser.gameCharacterName}</a>`
        : `${usr._gameUser.gameCharacterName}`;
    }

    usr.thumbnailUrl = articleList.thumbnailUrl;
    usr.title =
      String(articleList.title).indexOf('<strong') !== -1
        ? String(articleList.title)
        : String(articleList.title).replace(/[<>]/g, (tag: any) => {
            return replaceList[tag] || tag;
          });

    usr.summary = articleList.summary;
    usr.searchSummary = articleList.searchSummary;
    usr.hasThumbnail = (!!articleList.thumbnailUrl);

    return usr;
  }
};

export default User;
